// extracted by mini-css-extract-plugin
module.exports = {"iconsList":"SubscriptionIconsList_iconsList__8oJnc","iconItem":"SubscriptionIconsList_iconItem__1kDfL","lastItem":"SubscriptionIconsList_lastItem__hqj41"};